import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteContactInfo',
  props: {
  notes: { type: Array, default: () => [] },
},
  setup(__props) {



return { __sfc: true, }
}

})